// import React from "react";
// import contactUsImage from "../assets/contactUs.jpeg";
// // import TestimonialsSection from "./testimonials";
// import Newsletter from "./newsLetter";

// const ContactUs = () => {
//   return (
//     <>
//       <div
//         className="relative flex items-center justify-center"
//         style={{
//           width: "100%",
//           height: "559px",
//           marginTop: "85px",
//           borderRadius: "0px 0px 40px 40px",
//           background: "rgba(243, 249, 255, 1)",
//           boxSizing: "border-box",

//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             padding: "81px 0 286px",
//             textAlign: "center",
//           }}
//         >
//           <h2
//             style={{
//               fontFamily: "Manrope",
//               fontSize: "16px",
//               fontWeight: "700",
//               lineHeight: "21.86px",
//               letterSpacing: "2px",
//               color: "rgba(255, 165, 0, 1)",
//               margin: "0",
//               whiteSpace: "nowrap",
//             }}
//           >
//             CONTACT US
//           </h2>
//           <div
//             style={{
//               width: "605px",
//               height: "154px",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "16px",
//               marginTop: "16px",
//             }}
//           >
//             <h1
//               style={{
//                 fontFamily: "Manrope",
//                 fontSize: "64px",
//                 fontWeight: "700",
//                 lineHeight: "76.8px",
//                 color: "rgba(0, 42, 87, 1)",
//                 margin: "0",
//                 textAlign: "center",
//               }}
//             >
//               We’d love To hear From You
//             </h1>
//           </div>
//         </div>
//         <div
//           style={{
//             position: "absolute",
//             top: "349px",
//             left: "120px",
//             width: "calc(100% - 240px)",
//             height: "448px",
//             borderRadius: "20px",
//             border: "20px solid rgba(255, 255, 255, 1)",
//             overflow: "hidden",
//           }}
//         >
//           <img
//             src={contactUsImage}
//             alt="Contact Us"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               objectPosition: "50% 25%",
//             }}
//           />
//         </div>
//       </div>

//       <div
//         className="relative top-[288px] flex pl-[120px] flex-col lg:flex-row"
//         style={{ paddingLeft: "120px" }}
//       >
//         <div>
//           <div
//             style={{
//               width: "605px",
//               fontFamily: "Manrope",
//               fontSize: "42px",
//               fontWeight: "700",
//               lineHeight: "50.4px",
//               textAlign: "left",
//               color: "rgba(0, 42, 87, 1)",
//             }}
//           >
//             Send us a message
//           </div>
//           <div
//             style={{
//               width: "501px",
//               marginTop: "24px",
//               fontFamily: "Open Sans",
//               fontSize: "16px",
//               fontWeight: "400",
//               lineHeight: "25.6px",
//               textAlign: "left",
//               color: "rgba(67, 62, 63, 1)",
//             }}
//           >
//             We are a coalition of faith communities, community organizations,
//             and individuals working together to promote racial equity, civic
//             engagement, a fair economy, and participatory decision-making.
//           </div>
//           <div
//             style={{
//               position: "relative",
//               width: "182px",
//               height: "139px",
//               marginTop: "32px",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 marginBottom: "24px",
//               }}
//             >
//               <svg
//                 width="24"
//                 height="25"
//                 viewBox="0 0 24 25"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//                 style={{ marginRight: "8px" }}
//               >
//                 <path
//                   d="M16.5648 15.1714L13.0059 15.8474C10.602 14.6647 9.11707 13.3062 8.25289 11.1886L8.91827 7.69014L7.66051 4.41211H5.72858C4.03726 4.41211 2.7062 5.78536 3.05626 7.40762C3.58034 9.83645 4.75688 13.2677 7.38872 15.8474C10.1581 18.5619 13.9543 19.9824 16.6405 20.6952C18.3664 21.1531 19.9192 19.8202 19.9192 18.0672V16.4244L16.5648 15.1714Z"
//                   stroke="#FFA500"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//               <span
//                 style={{
//                   width: "122px",
//                   fontFamily: "Manrope",
//                   fontSize: "16px",
//                   fontWeight: "400",
//                   lineHeight: "21px",
//                   textAlign: "left",
//                   color: "rgba(0, 42, 87, 1)",
//                 }}
//               >
//                 217-544-2297
//               </span>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 marginBottom: "24px",
//               }}
//             >
//               <svg
//                 width="24"
//                 height="24"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//                 style={{ marginRight: "8px" }}
//               >
//                 <path
//                   d="M2.32031 17.1621V6.8079C2.32031 5.24851 3.66344 3.98438 5.3203 3.98438H19.3216C20.9784 3.98438 22.3216 5.24851 22.3216 6.8079V17.1621C22.3216 18.7215 20.9784 19.9856 19.3216 19.9856H5.3203C3.66346 19.9856 2.32031 18.7215 2.32031 17.1621Z"
//                   stroke="#FFA500"
//                 />
//                 <path
//                   d="M6.58008 8.35547L12.3865 11.2701L18.193 8.35547"
//                   stroke="#FFA500"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//               <span
//                 style={{
//                   width: "120px",
//                   fontFamily: "Manrope",
//                   fontSize: "16px",
//                   fontWeight: "400",
//                   lineHeight: "21px",
//                   textAlign: "left",
//                   color: "rgba(0, 42, 87, 1)",
//                 }}
//               >
//                 info@faithcoalition-il.org
//               </span>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <svg
//                 width="24"
//                 height="24"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//                 style={{ marginRight: "8px" }}
//               >
//                 <path
//                   d="M12.0002 1.92773C14.2167 1.92773 16.3423 2.80822 17.9096 4.37548C19.4769 5.94275 20.3574 8.06843 20.3574 10.2849C20.3574 13.8163 17.8759 17.6649 12.9774 21.8717C12.705 22.1057 12.3577 22.2342 11.9986 22.2339C11.6395 22.2336 11.2925 22.1045 11.0205 21.87L10.6965 21.5889C6.01478 17.4917 3.64307 13.7374 3.64307 10.2849C3.64307 8.06843 4.52355 5.94275 6.09082 4.37548C7.65808 2.80822 9.78376 1.92773 12.0002 1.92773ZM12.0002 3.21345C10.1247 3.21345 8.3261 3.95847 6.99995 5.28462C5.6738 6.61077 4.92878 8.40942 4.92878 10.2849C4.92878 13.2866 7.11278 16.7452 11.5408 20.6194L11.8605 20.8963C11.8994 20.9297 11.9489 20.9481 12.0002 20.9481C12.0515 20.9481 12.101 20.9297 12.1399 20.8963C16.7822 16.9089 19.0716 13.3577 19.0716 10.2849C19.0716 9.35624 18.8887 8.4367 18.5334 7.57876C18.178 6.72081 17.6571 5.94127 17.0005 5.28462C16.3438 4.62798 15.5643 4.1071 14.7063 3.75173C13.8484 3.39636 12.9288 3.21345 12.0002 3.21345ZM12.0002 7.07059C12.8527 7.07059 13.6703 7.40924 14.2731 8.01203C14.8758 8.61483 15.2145 9.4324 15.2145 10.2849C15.2145 11.1374 14.8758 11.9549 14.2731 12.5577C13.6703 13.1605 12.8527 13.4992 12.0002 13.4992C11.1477 13.4992 10.3302 13.1605 9.72737 12.5577C9.12457 11.9549 8.78592 11.1374 8.78592 10.2849C8.78592 9.4324 9.12457 8.61483 9.72737 8.01203C10.3302 7.40924 11.1477 7.07059 12.0002 7.07059ZM12.0002 8.35631C11.4887 8.35631 10.9982 8.55949 10.6365 8.92117C10.2748 9.28285 10.0716 9.77339 10.0716 10.2849C10.0716 10.7964 10.2748 11.2869 10.6365 11.6486C10.9982 12.0103 11.4887 12.2134 12.0002 12.2134C12.5117 12.2134 13.0022 12.0103 13.3639 11.6486C13.7256 11.2869 13.9288 10.7964 13.9288 10.2849C13.9288 9.77339 13.7256 9.28285 13.3639 8.92117C13.0022 8.55949 12.5117 8.35631 12.0002 8.35631Z"
//                   fill="#FFA500"
//                 />
//               </svg>
//               <span
//                 style={{
//                   width: "148px",
//                   fontFamily: "Manrope",
//                   fontSize: "16px",
//                   fontWeight: "400",
//                   lineHeight: "21px",
//                   textAlign: "left",
//                   color: "rgba(0, 42, 87, 1)",
//                 }}
//               >
//                 2208 E. Kansas
//                 <br />
//                 Springfield, IL 62703
//               </span>
//             </div>
//           </div>
//           <div
//             style={{
//               width: "199px",
//               height: "68px",
//               top: "1436px",
//               left: "117px",
//               gap: "10px",
//               opacity: "0px",
//               marginTop: "177px",
//             }}
//           >
//             <div
//               style={{
//                 width: "199px",
//                 height: "26px",
//                 gap: "0px",
//                 opacity: "0px",
//                 fontFamily: "Open Sans",
//                 fontSize: "16px",
//                 fontWeight: "400",
//                 lineHeight: "25.6px",
//                 textAlign: "left",
//                 color: "rgba(67, 62, 63, 1)",
//               }}
//             >
//               Follow us on social media!
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 gap: "8px",
//                 opacity: "1",
//                 paddingTop: "10px",
//               }}
//             >
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 32 32"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <rect width="32" height="32" rx="16" fill="#F1F1F1" />
//                 <g clipPath="url(#clip0_365_972)">
//                   <g clipPath="url(#clip1_365_972)">
//                     <g clipPath="url(#clip2_365_972)">
//                       <path
//                         d="M14.9872 17.3409L11.3753 21.3994H10.627L14.7596 16.7546L15.0362 16.4437L14.7808 16.1153L10.2666 10.3105H13.3014L16.1224 13.9783L16.4908 14.4571L16.8923 14.0057L20.1796 10.3105H20.9264L17.111 14.5989L16.8359 14.9081L17.0882 15.2361L21.8289 21.3994H18.8922L15.7554 17.3663L15.3866 16.8921L14.9872 17.3409ZM18.8286 20.9789L18.9787 21.1719H19.2232H20.3788H21.3941L20.7751 20.3671L13.316 10.6687L13.1659 10.4736H12.9197H11.6797H10.6573L11.285 11.2805L18.8286 20.9789Z"
//                         fill="#FFA500"
//                         stroke="#FFA500"
//                       />
//                     </g>
//                   </g>
//                 </g>
//                 <defs>
//                   <clipPath id="clip0_365_972">
//                     <rect
//                       width="14"
//                       height="13"
//                       fill="white"
//                       transform="translate(9 9.5)"
//                     />
//                   </clipPath>
//                   <clipPath id="clip1_365_972">
//                     <rect
//                       width="14"
//                       height="13"
//                       fill="white"
//                       transform="translate(9 9.5)"
//                     />
//                   </clipPath>
//                   <clipPath id="clip2_365_972">
//                     <rect
//                       width="14"
//                       height="13"
//                       fill="white"
//                       transform="translate(9 9.5)"
//                     />
//                   </clipPath>
//                 </defs>
//               </svg>
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 32 32"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <rect width="32" height="32" rx="16" fill="#F1F1F1" />
//                 <g clipPath="url(#clip0_365_977)">
//                   <g clipPath="url(#clip1_365_977)">
//                     <g clipPath="url(#clip2_365_977)">
//                       <path
//                         d="M16.3546 14.6379H19.5546L19.199 16.0602H16.3546V22.4602H14.9323V16.0602H12.0879V14.6379H14.9323V13.3067C14.9323 12.0388 15.0646 11.5787 15.3121 11.1151C15.5546 10.657 15.9292 10.2824 16.3873 10.0399C16.8509 9.79242 17.311 9.66016 18.5789 9.66016C18.9501 9.66016 19.2758 9.69571 19.5546 9.76682V11.0824H18.5789C17.6374 11.0824 17.3508 11.1378 17.0586 11.2943C16.8424 11.4095 16.6817 11.5702 16.5665 11.7864C16.41 12.0786 16.3546 12.3652 16.3546 13.3067V14.6379Z"
//                         fill="#FFA500"
//                         stroke="#FFA500"
//                         strokeWidth="0.8"
//                       />
//                     </g>
//                   </g>
//                 </g>
//                 <defs>
//                   <clipPath id="clip0_365_977">
//                     <rect
//                       width="10"
//                       height="14"
//                       fill="white"
//                       transform="translate(11 9)"
//                     />
//                   </clipPath>
//                   <clipPath id="clip1_365_977">
//                     <rect
//                       width="10"
//                       height="14"
//                       fill="white"
//                       transform="translate(11 9)"
//                     />
//                   </clipPath>
//                   <clipPath id="clip2_365_977)">
//                     <rect
//                       width="10"
//                       height="14"
//                       fill="white"
//                       transform="translate(11 9)"
//                     />
//                   </clipPath>
//                 </defs>
//               </svg>
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 32 32"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <rect width="32" height="32" rx="16" fill="#F1F1F1" />
//                 <g clipPath="url(#clip0_365_982)">
//                   <g clipPath="url(#clip1_365_982)">
//                     <g clipPath="url(#clip2_365_982)">
//                       <path
//                         d="M21.0798 12.6561L21.0865 12.663C21.1753 12.7527 21.268 12.9491 21.3394 13.192C21.3716 13.3018 21.3944 13.4028 21.4091 13.4763C21.4163 13.5127 21.4214 13.5417 21.4246 13.5608L21.4279 13.5814L21.4284 13.5852L21.432 13.616C21.4351 13.6434 21.4396 13.6841 21.4451 13.7363C21.4561 13.8406 21.4707 13.9903 21.4854 14.1701C21.5149 14.5311 21.544 15.0076 21.544 15.4796V16.399C21.544 16.8722 21.5149 17.3487 21.4854 17.7093C21.4707 17.889 21.4561 18.0385 21.4451 18.1426C21.4397 18.1946 21.4351 18.2352 21.432 18.2626L21.4284 18.2933L21.428 18.2969L21.4246 18.3178C21.4214 18.3369 21.4163 18.3659 21.4091 18.4023C21.3944 18.4758 21.3716 18.5769 21.3394 18.6867C21.268 18.9295 21.1753 19.1259 21.0865 19.2155L21.0798 19.2225C20.7974 19.5191 20.5115 19.549 20.2597 19.5754C20.2339 19.5781 20.2085 19.5808 20.1835 19.5837C19.3536 19.6426 18.3121 19.6736 17.4715 19.6898C17.0504 19.6979 16.6818 19.7022 16.4185 19.7046C16.2869 19.7057 16.1817 19.7064 16.1095 19.7067L16.0268 19.7071L16.0055 19.7071L16.0002 19.7072L15.9952 19.7071L15.969 19.7068L15.868 19.7058C15.7806 19.7048 15.6544 19.7034 15.5 19.7013C15.1911 19.6972 14.7692 19.6908 14.3175 19.6815C13.419 19.663 12.4293 19.6335 11.9584 19.5906C11.8777 19.5758 11.799 19.5653 11.7223 19.5551C11.4284 19.5159 11.1626 19.4805 10.9169 19.2225L10.9113 19.2167C10.8231 19.127 10.7307 18.9303 10.6595 18.6872C10.6273 18.5773 10.6046 18.4762 10.59 18.4026C10.5828 18.3661 10.5776 18.337 10.5745 18.318L10.5711 18.2973L10.5707 18.2934L10.5671 18.2626C10.564 18.2352 10.5594 18.1945 10.5539 18.1423C10.543 18.038 10.5283 17.8883 10.5136 17.7085C10.4841 17.3475 10.4551 16.871 10.4551 16.399V15.4796C10.4551 15.008 10.4847 14.5318 10.5147 14.1709C10.5297 13.9912 10.5447 13.8416 10.5558 13.7373C10.5614 13.6852 10.566 13.6445 10.5692 13.6171L10.5729 13.5864L10.5735 13.5815L10.5737 13.5801L10.5769 13.5595C10.5801 13.5404 10.5851 13.5114 10.5922 13.475C10.6067 13.4016 10.6292 13.3006 10.6612 13.1909C10.7319 12.9482 10.8242 12.7523 10.9125 12.663L10.9192 12.6561C11.2017 12.3595 11.4876 12.3296 11.7394 12.3032C11.7652 12.3005 11.7908 12.2978 11.8159 12.2949C12.6453 12.2349 13.6858 12.2044 14.5258 12.1891C14.9466 12.1815 15.3148 12.1777 15.5778 12.1757C15.7093 12.1748 15.8143 12.1743 15.8864 12.1741L15.969 12.1739L15.9902 12.1738H15.9955L15.9968 12.1738H16.0019L16.0035 12.1738H16.0088L16.03 12.1739L16.1126 12.1741C16.1847 12.1743 16.2898 12.1748 16.4212 12.1757C16.6842 12.1777 17.0525 12.1815 17.4732 12.1891C18.3133 12.2044 19.3538 12.2349 20.1832 12.2949C20.2083 12.2978 20.2338 12.3005 20.2597 12.3032C20.5114 12.3296 20.7974 12.3595 21.0798 12.6561ZM14.2505 17.5152V18.339L14.9813 17.9587L18.2467 16.2596L19.0961 15.8176L18.2479 15.3732L14.9825 13.6623L14.2505 13.2787V14.1052V17.5152Z"
//                         fill="#FFA500"
//                         stroke="#FFA500"
//                       />
//                     </g>
//                   </g>
//                 </g>
//                 <defs>
//                   <clipPath id="clip0_365_982">
//                     <rect
//                       width="14"
//                       height="10"
//                       fill="white"
//                       transform="translate(9 11)"
//                     />
//                   </clipPath>
//                   <clipPath id="clip1_365_982">
//                     <rect
//                       width="14"
//                       height="10"
//                       fill="white"
//                       transform="translate(9 11)"
//                     />
//                   </clipPath>
//                   <clipPath id="clip2_365_982">
//                     <rect
//                       width="14"
//                       height="10"
//                       fill="white"
//                       transform="translate(9 11)"
//                     />
//                   </clipPath>
//                 </defs>
//               </svg>
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 32 32"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <rect width="32" height="32" rx="16" fill="#F1F1F1" />
//                 <g clipPath="url(#clip0_365_987)">
//                   <g clipPath="url(#clip1_365_987)">
//                     <g clipPath="url(#clip2_365_987)">
//                       <path
//                         fillRule="evenodd"
//                         clipRule="evenodd"
//                         d="M18.7813 11.9801C18.653 12.0658 18.553 12.1876 18.494 12.3301C18.446 12.446 18.4269 12.5713 18.4375 12.6954C18.44 12.7239 18.444 12.7525 18.4496 12.7808C18.4797 12.9321 18.554 13.0711 18.6631 13.1802C18.7721 13.289 18.9114 13.3636 19.0625 13.3936C19.0913 13.3994 19.1203 13.4034 19.1494 13.4059C19.273 13.4163 19.3978 13.397 19.5132 13.3492C19.6557 13.2902 19.7775 13.1902 19.8632 13.062C19.9026 13.0029 19.9336 12.9392 19.9556 12.8725C19.9813 12.7942 19.9947 12.7119 19.9947 12.6286C19.9947 12.6161 19.9944 12.6037 19.9938 12.5913C19.9934 12.5824 19.9928 12.5734 19.992 12.5645C19.9782 12.397 19.9106 12.2382 19.7991 12.112C19.7885 12.1001 19.7776 12.0884 19.7662 12.0771C19.7639 12.0747 19.7615 12.0723 19.7591 12.07C19.6227 11.9371 19.4427 11.8589 19.2532 11.8496C19.2516 11.8495 19.25 11.8494 19.2484 11.8493C19.2372 11.8489 19.226 11.8486 19.2147 11.8486C19.1274 11.8486 19.0413 11.8632 18.9597 11.8914C18.897 11.9131 18.8371 11.9428 18.7813 11.9801ZM18.9559 10.8675C19.0428 10.8834 19.1291 10.9024 19.2147 10.9245C19.3288 10.954 19.4416 10.9891 19.5527 11.0296C19.8408 11.1366 20.1002 11.3088 20.3105 11.5327C20.3157 11.5383 20.321 11.544 20.3262 11.5496C20.5392 11.7493 20.7056 11.9934 20.8137 12.2646C20.8573 12.3841 20.8946 12.5056 20.9254 12.6286C20.9456 12.7095 20.9631 12.7911 20.9778 12.8731C21.0147 13.0795 21.0338 13.2891 21.0347 13.4996C21.0672 14.1496 21.0737 14.3901 21.0737 16.0996C21.0737 17.8091 21.0672 18.0496 21.0347 18.6996C21.0299 19.1122 20.9552 19.521 20.8137 19.9086C20.7098 20.1915 20.5432 20.4471 20.3262 20.6561C20.1153 20.871 19.8603 21.0373 19.5787 21.1436C19.1911 21.2851 18.7823 21.3598 18.3696 21.3646C17.7326 21.3996 17.5116 21.4036 15.7696 21.4036C14.0601 21.4036 13.8196 21.4036 13.1696 21.3646C12.5256 21.3727 11.9914 21.3066 11.4861 21.1696C11.6394 21.0579 11.396 20.8919 11.1936 20.6821C10.9779 20.4733 10.8133 20.2175 10.7126 19.9346C10.554 19.5415 10.4659 19.1234 10.4526 18.6996C10.4526 18.4517 10.447 18.2633 10.44 18.0303C10.4286 17.6524 10.4136 17.1571 10.4136 16.0996C10.4136 14.3901 10.4136 14.1496 10.4526 13.4996C10.4556 13.0778 10.5326 12.6598 10.6801 12.2646C10.7946 11.9903 10.9702 11.7457 11.1936 11.5496C11.3911 11.3261 11.6352 11.1486 11.9086 11.0296C12.3049 10.8866 12.7224 10.8119 13.1436 10.8086C13.3916 10.8086 13.5799 10.8029 13.8129 10.7959C14.1908 10.7845 14.6862 10.7696 15.7436 10.7696C17.4531 10.7696 17.6937 10.7696 18.3436 10.8086C18.5494 10.811 18.7542 10.8307 18.9559 10.8675ZM21.9057 20.3571C21.7421 20.7914 21.4846 21.1843 21.1517 21.5076C20.8298 21.8408 20.4364 22.0964 20.0012 22.2551C19.4959 22.4461 18.9617 22.5494 18.4216 22.5606C17.7326 22.5996 17.5116 22.5996 15.7436 22.5996C13.9756 22.5996 13.7546 22.5996 13.0656 22.5606C12.5256 22.5494 11.9914 22.4461 11.4861 22.2551C11.0517 22.0948 10.6587 21.8394 10.3356 21.5076C10.0025 21.1857 9.74687 20.7923 9.58815 20.3571C9.39716 19.8518 9.29384 19.3176 9.28265 18.7776C9.24365 18.0886 9.24365 17.8676 9.24365 16.0996C9.24365 14.3316 9.24365 14.1106 9.28265 13.4216C9.29384 12.8816 9.39716 12.3474 9.58815 11.8421C9.74687 11.4069 10.0025 11.0135 10.3356 10.6916C10.6587 10.3598 11.0517 10.1044 11.4861 9.94411C11.9914 9.75311 12.5256 9.6498 13.0656 9.63861C13.7546 9.59961 13.9756 9.59961 15.7436 9.59961C17.5116 9.59961 17.7326 9.59961 18.4216 9.63861C18.9617 9.6498 19.4959 9.75311 20.0012 9.94411C20.4364 10.1028 20.8298 10.3584 21.1517 10.6916C21.4832 11.0161 21.7404 11.4087 21.9057 11.8421C22.0911 12.3487 22.192 12.8823 22.2047 13.4216C22.2437 14.1106 22.2437 14.3316 22.2437 16.0996C22.2437 17.1881 22.2289 17.6902 22.2175 18.0762C22.2104 18.3171 22.2047 18.5128 22.2047 18.7776C22.192 19.3169 22.0911 19.8505 21.9057 20.3571ZM13.3946 18.4597C12.928 17.9941 12.6099 17.4005 12.4805 16.7541C12.3511 16.1077 12.4162 15.4375 12.6676 14.828C12.919 14.2186 13.3454 13.6974 13.8929 13.3302C14.4404 12.9631 15.0844 12.7664 15.7436 12.7651C16.1823 12.7634 16.617 12.8484 17.0227 13.0153C17.2127 13.0935 17.3945 13.1888 17.5661 13.3C17.7606 13.426 17.9419 13.5722 18.1068 13.7366C18.1067 13.7366 18.1068 13.7367 18.1068 13.7366C18.107 13.7369 18.1074 13.7373 18.1077 13.7375C18.2728 13.9024 18.4198 14.0837 18.5464 14.2784C18.6578 14.4497 18.7535 14.6313 18.8319 14.821C18.9996 15.2264 19.0855 15.6609 19.0847 16.0996C19.0847 16.7588 18.8892 17.4033 18.5231 17.9515C18.1571 18.4997 17.6366 18.9271 17.0277 19.1797C16.4188 19.4322 15.7487 19.4987 15.102 19.3705C14.4554 19.2424 13.8612 18.9255 13.3946 18.4597ZM19.3702 12.473C19.3701 12.4729 19.3702 12.473 19.3702 12.473V12.473ZM19.3702 12.473L19.2147 12.6285L19.418 12.7127C19.4291 12.6859 19.4347 12.6573 19.4347 12.6286C19.4347 12.6143 19.4333 12.6 19.4305 12.5858C19.422 12.5432 19.4009 12.5038 19.3702 12.473ZM19.2147 12.6285L19.418 12.7127C19.4124 12.7261 19.4056 12.7389 19.3976 12.7508C19.3816 12.7748 19.361 12.7954 19.3369 12.8115C19.3249 12.8196 19.3122 12.8264 19.2989 12.8319C19.2989 12.8318 19.2989 12.8319 19.2989 12.8319C19.2724 12.8428 19.2437 12.8486 19.2147 12.8486C19.2001 12.8486 19.1858 12.8472 19.1717 12.8444L19.2147 12.6285ZM19.0591 12.7841C19.059 12.7841 19.0591 12.7842 19.0591 12.7841V12.7841ZM19.2147 12.6285L19.0591 12.7841C19.09 12.8151 19.1294 12.836 19.1717 12.8444L19.2147 12.6285ZM19.0591 12.7841L19.2147 12.6285L19.0114 12.5444C19.0004 12.5709 18.9946 12.5995 18.9946 12.6286C18.9946 12.6432 18.9961 12.6576 18.9989 12.6716C19.0074 12.7139 19.0281 12.7531 19.0591 12.7841ZM19.0114 12.5444L19.2147 12.6285L19.2575 12.4128C19.2434 12.41 19.229 12.4086 19.2147 12.4086C19.186 12.4086 19.1574 12.4142 19.1306 12.4253C19.1305 12.4254 19.1306 12.4253 19.1306 12.4253C19.1172 12.4309 19.1044 12.4377 19.0925 12.4457C19.0685 12.4617 19.0478 12.4823 19.0317 12.5064M19.2147 12.6285L19.2575 12.4128C19.3003 12.4213 19.3396 12.4424 19.3702 12.473L19.2147 12.6285ZM19.0114 12.5444C19.0169 12.5311 19.0237 12.5184 19.0317 12.5064L19.0114 12.5444ZM14.5411 17.8993C14.8971 18.1371 15.3156 18.2641 15.7436 18.2641C16.0279 18.2641 16.3094 18.2081 16.572 18.0994C16.8346 17.9906 17.0732 17.8311 17.2742 17.6301C17.4752 17.4292 17.6346 17.1905 17.7434 16.9279C17.8522 16.6653 17.9081 16.3839 17.9081 16.0996C17.9081 15.6715 17.7812 15.253 17.5434 14.8971C17.3055 14.5411 16.9675 14.2637 16.572 14.0999C16.1765 13.9361 15.7412 13.8932 15.3214 13.9767C14.9015 14.0602 14.5158 14.2664 14.2131 14.5691C13.9104 14.8718 13.7043 15.2575 13.6207 15.6773C13.5372 16.0972 13.5801 16.5324 13.7439 16.9279C13.9077 17.3234 14.1852 17.6615 14.5411 17.8993Z"
//                         fill="#FFA500"
//                       />
//                     </g>
//                   </g>
//                 </g>
//                 <defs>
//                   <clipPath id="clip0_365_987">
//                     <rect
//                       width="14"
//                       height="14"
//                       fill="white"
//                       transform="translate(9 9)"
//                     />
//                   </clipPath>
//                   <clipPath id="clip1_365_987">
//                     <rect
//                       width="14"
//                       height="14"
//                       fill="white"
//                       transform="translate(9 9)"
//                     />
//                   </clipPath>
//                   <clipPath id="clip2_365_987">
//                     <rect
//                       width="14"
//                       height="14"
//                       fill="white"
//                       transform="translate(9 9)"
//                     />
//                   </clipPath>
//                 </defs>
//               </svg>
//             </div>
//           </div>
//         </div>

//         <div
//           style={{
//             width: "603px",
//             height: "568px",
//             gap: "0px",
//             borderRadius: "20px",
//             background: "rgba(255, 255, 255, 1)",
//             border: "1px solid rgba(181, 179, 179, 1)",
//             marginLeft: "75px",
//             marginRight: "120px",
//             padding: "32px",
//             boxSizing: "border-box",
//           }}
//         >
//           <div style={{ display: "flex", justifyContent: "space-between" }}>
//             <div style={{ width: "257px", marginRight: "15px" }}>
//               <div
//                 style={{
//                   width: "80px",
//                   height: "18px",
//                   fontFamily: "Manrope",
//                   fontSize: "16px",
//                   fontWeight: "500",
//                   lineHeight: "18px",
//                   textAlign: "left",
//                   color: "rgba(0, 42, 87, 1)",
//                   marginBottom: "8px",
//                 }}
//               >
//                 First Name
//               </div>
//               <input
//                 type="text"
//                 style={{
//                   width: "100%",
//                   height: "48px",
//                   borderRadius: "30px",
//                   border: "1px solid rgba(181, 179, 179, 1)",
//                   padding: "0 15px",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>
//             <div style={{ width: "257px" }}>
//               <div
//                 style={{
//                   width: "79px",
//                   height: "18px",
//                   fontFamily: "Manrope",
//                   fontSize: "16px",
//                   fontWeight: "500",
//                   lineHeight: "18px",
//                   textAlign: "left",
//                   color: "rgba(0, 42, 87, 1)",
//                   marginBottom: "8px",
//                 }}
//               >
//                 Last Name
//               </div>
//               <input
//                 type="text"
//                 style={{
//                   width: "100%",
//                   height: "48px",
//                   borderRadius: "30px",
//                   border: "1px solid rgba(181, 179, 179, 1)",
//                   padding: "0 15px",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>
//           </div>

//           <div style={{ marginTop: "24px" }}>
//             <div
//               style={{
//                 width: "105px",
//                 height: "18px",
//                 fontFamily: "Manrope",
//                 fontSize: "16px",
//                 fontWeight: "500",
//                 lineHeight: "18px",
//                 textAlign: "left",
//                 color: "rgba(0, 42, 87, 1)",
//                 marginBottom: "8px",
//               }}
//             >
//               Email Address
//             </div>
//             <input
//               type="email"
//               style={{
//                 width: "100%",
//                 height: "48px",
//                 borderRadius: "30px",
//                 border: "1px solid rgba(181, 179, 179, 1)",
//                 padding: "0 15px",
//                 boxSizing: "border-box",
//               }}
//             />
//           </div>

//           <div style={{ marginTop: "24px" }}>
//             <div
//               style={{
//                 width: "68px",
//                 height: "18px",
//                 fontFamily: "Manrope",
//                 fontSize: "16px",
//                 fontWeight: "500",
//                 lineHeight: "18px",
//                 textAlign: "left",
//                 color: "rgba(0, 42, 87, 1)",
//                 marginBottom: "8px",
//               }}
//             >
//               Message
//             </div>
//             <textarea
//               style={{
//                 width: "100%",
//                 height: "181px",
//                 borderRadius: "30px",
//                 border: "1px solid rgba(181, 179, 179, 1)",
//                 padding: "15px",
//                 boxSizing: "border-box",
//                 resize: "none",
//               }}
//             />
//           </div>

//           <button
//             style={{
//               width: "100%",
//               height: "48px",
//               marginTop: "24px",
//               borderRadius: "30px",
//               background: "rgba(0, 42, 87, 1)",
//               color: "rgba(255, 255, 255, 1)",
//               fontFamily: "Manrope",
//               fontSize: "16px",
//               fontWeight: "500",
//               lineHeight: "18px",
//               textAlign: "center",
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             Submit
//           </button>
//         </div>
//       </div>

//       {/* <div style={{ paddingTop: "326px" }}>
//         <TestimonialsSection />
//       </div> */}
// <div
//   style={{
//     width: "100%",
//     height: "448px",
//     top: "1554px",
//     gap: "0px",
//     opacity: "1",
//     margin: "0 auto",
//     marginTop: "326px",
//   }}
// >
//   <iframe
//     title="Google Maps Location"
//     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.2838494377847!2d-89.65293258430823!3d39.781721979443954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x887525f4e153c67b%3A0x34d8f648f13727c2!2s2208%20E%20Kansas%20St%2C%20Springfield%2C%20IL%2062703%2C%20USA!5e0!3m2!1sen!2sin!4v1628096164148!5m2!1sen!2sin"
//     width="100%"
//     height="100%"
//     style={{ border: 0 }}
//     allowFullScreen=""
//     loading="lazy"
//   ></iframe>
// </div>
//       <div style={{ paddingTop: "81px", paddingBottom: "87px" }}>
//         <Newsletter />
//       </div>
//     </>
//   );
// };

// export default ContactUs;

import React from "react";
import contactUsImage from "../assets/contactUs.jpeg";
// import TestimonialsSection from "./testimonials";
import Newsletter from "./newsLetter";

const ContactUs = () => {
  return (
    <>
      <div className="relative flex items-center justify-center w-full h-[400px] sm:h-[559px] mt-[40px] sm:mt-[85px] bg-custom-lightblue rounded-b-[40px]">
        <div className="flex flex-col items-center pt-[40px] pb-[100px] sm:pt-[81px] sm:pb-[286px] text-center">
          <h2 className="font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-custom-orange whitespace-nowrap">
            CONTACT US
          </h2>
          <div className="w-full max-w-[605px] flex flex-col items-center justify-center gap-[16px] mt-[16px] px-[16px]">
            <h1 className="font-bold text-[32px] leading-[38.4px] sm:text-[48px] sm:leading-[57.6px] md:text-[64px] md:leading-[76.8px] text-custom-blue text-center">
              We’d love To hear From You
            </h1>
          </div>
        </div>
        <div className="absolute top-[250px] sm:top-[349px] left-[16px] right-[16px] sm:left-[120px] sm:right-[120px] h-[200px] sm:h-[448px] rounded-lg border-[10px] sm:border-[20px] border-white overflow-hidden">
          <img
            src={contactUsImage}
            alt="Contact Us"
            className="w-full h-full object-cover object-[50%_25%]"
          />
        </div>
      </div>

      <div className="relative top-[150px] sm:top-[288px] flex flex-col lg:flex-row px-[16px] sm:px-0 sm:pl-[120px]">
        <div>
          <div className="w-full max-w-[605px] font-primary text-[24px] sm:text-[36px] md:text-[42px] font-bold leading-tight text-left text-custom-blue">
            Send us a message
          </div>
          <div className="w-full max-w-[501px] mt-[24px] font-secondary text-[14px] sm:text-[16px] leading-[22.4px] sm:leading-[25.6px] text-left text-custom-lightgray">
            We are a coalition of faith communities, community organizations,
            and individuals working together to promote racial equity, civic
            engagement, a fair economy, and participatory decision-making.
          </div>
          <div className="relative w-full max-w-[182px] h-[139px] mt-[32px]">
            <div className="flex items-center mb-[24px]">
              {/* Replace the SVG with your actual SVG code */}
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "8px" }}
              >
                <path
                  d="M16.5648 15.1714L13.0059 15.8474C10.602 14.6647 9.11707 13.3062 8.25289 11.1886L8.91827 7.69014L7.66051 4.41211H5.72858C4.03726 4.41211 2.7062 5.78536 3.05626 7.40762C3.58034 9.83645 4.75688 13.2677 7.38872 15.8474C10.1581 18.5619 13.9543 19.9824 16.6405 20.6952C18.3664 21.1531 19.9192 19.8202 19.9192 18.0672V16.4244L16.5648 15.1714Z"
                  stroke="#FFA500"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="w-[122px] font-primary text-[16px] leading-[21px] text-left text-custom-blue">
                217-544-2297
              </span>
            </div>
            <div className="flex items-center mb-[24px]">
              {/* Replace the SVG with your actual SVG code */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "8px" }}
              >
                <path
                  d="M2.32031 17.1621V6.8079C2.32031 5.24851 3.66344 3.98438 5.3203 3.98438H19.3216C20.9784 3.98438 22.3216 5.24851 22.3216 6.8079V17.1621C22.3216 18.7215 20.9784 19.9856 19.3216 19.9856H5.3203C3.66346 19.9856 2.32031 18.7215 2.32031 17.1621Z"
                  stroke="#FFA500"
                />
                <path
                  d="M6.58008 8.35547L12.3865 11.2701L18.193 8.35547"
                  stroke="#FFA500"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="w-[120px] font-primary text-[16px] leading-[21px] text-left text-custom-blue">
                info@faithcoalition-il.org
              </span>
            </div>
            <div className="flex items-center">
              {/* Replace the SVG with your actual SVG code */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "8px" }}
              >
                <path
                  d="M12.0002 1.92773C14.2167 1.92773 16.3423 2.80822 17.9096 4.37548C19.4769 5.94275 20.3574 8.06843 20.3574 10.2849C20.3574 13.8163 17.8759 17.6649 12.9774 21.8717C12.705 22.1057 12.3577 22.2342 11.9986 22.2339C11.6395 22.2336 11.2925 22.1045 11.0205 21.87L10.6965 21.5889C6.01478 17.4917 3.64307 13.7374 3.64307 10.2849C3.64307 8.06843 4.52355 5.94275 6.09082 4.37548C7.65808 2.80822 9.78376 1.92773 12.0002 1.92773ZM12.0002 3.21345C10.1247 3.21345 8.3261 3.95847 6.99995 5.28462C5.6738 6.61077 4.92878 8.40942 4.92878 10.2849C4.92878 13.2866 7.11278 16.7452 11.5408 20.6194L11.8605 20.8963C11.8994 20.9297 11.9489 20.9481 12.0002 20.9481C12.0515 20.9481 12.101 20.9297 12.1399 20.8963C16.7822 16.9089 19.0716 13.3577 19.0716 10.2849C19.0716 9.35624 18.8887 8.4367 18.5334 7.57876C18.178 6.72081 17.6571 5.94127 17.0005 5.28462C16.3438 4.62798 15.5643 4.1071 14.7063 3.75173C13.8484 3.39636 12.9288 3.21345 12.0002 3.21345ZM12.0002 7.07059C12.8527 7.07059 13.6703 7.40924 14.2731 8.01203C14.8758 8.61483 15.2145 9.4324 15.2145 10.2849C15.2145 11.1374 14.8758 11.9549 14.2731 12.5577C13.6703 13.1605 12.8527 13.4992 12.0002 13.4992C11.1477 13.4992 10.3302 13.1605 9.72737 12.5577C9.12457 11.9549 8.78592 11.1374 8.78592 10.2849C8.78592 9.4324 9.12457 8.61483 9.72737 8.01203C10.3302 7.40924 11.1477 7.07059 12.0002 7.07059ZM12.0002 8.35631C11.4887 8.35631 10.9982 8.55949 10.6365 8.92117C10.2748 9.28285 10.0716 9.77339 10.0716 10.2849C10.0716 10.7964 10.2748 11.2869 10.6365 11.6486C10.9982 12.0103 11.4887 12.2134 12.0002 12.2134C12.5117 12.2134 13.0022 12.0103 13.3639 11.6486C13.7256 11.2869 13.9288 10.7964 13.9288 10.2849C13.9288 9.77339 13.7256 9.28285 13.3639 8.92117C13.0022 8.55949 12.5117 8.35631 12.0002 8.35631Z"
                  fill="#FFA500"
                />
              </svg>
              <span className="w-[148px] font-primary text-[16px] leading-[21px] text-left text-custom-blue">
                2208 E. Kansas
                <br />
                Springfield, IL 62703
              </span>
            </div>
          </div>
          <div className="w-[199px] h-[68px] gap-[10px] lg:mt-[177px]">
            <div className="w-[199px] h-[26px] font-secondary text-[16px] leading-[25.6px] text-left text-custom-lightgray">
              Follow us on social media!
            </div>
            <div className="flex gap-[8px] pt-[10px]">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="32" height="32" rx="16" fill="#F1F1F1" />
                <g clipPath="url(#clip0_365_972)">
                  <g clipPath="url(#clip1_365_972)">
                    <g clipPath="url(#clip2_365_972)">
                      <path
                        d="M14.9872 17.3409L11.3753 21.3994H10.627L14.7596 16.7546L15.0362 16.4437L14.7808 16.1153L10.2666 10.3105H13.3014L16.1224 13.9783L16.4908 14.4571L16.8923 14.0057L20.1796 10.3105H20.9264L17.111 14.5989L16.8359 14.9081L17.0882 15.2361L21.8289 21.3994H18.8922L15.7554 17.3663L15.3866 16.8921L14.9872 17.3409ZM18.8286 20.9789L18.9787 21.1719H19.2232H20.3788H21.3941L20.7751 20.3671L13.316 10.6687L13.1659 10.4736H12.9197H11.6797H10.6573L11.285 11.2805L18.8286 20.9789Z"
                        fill="#FFA500"
                        stroke="#FFA500"
                      />
                    </g>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_365_972">
                    <rect
                      width="14"
                      height="13"
                      fill="white"
                      transform="translate(9 9.5)"
                    />
                  </clipPath>
                  <clipPath id="clip1_365_972">
                    <rect
                      width="14"
                      height="13"
                      fill="white"
                      transform="translate(9 9.5)"
                    />
                  </clipPath>
                  <clipPath id="clip2_365_972">
                    <rect
                      width="14"
                      height="13"
                      fill="white"
                      transform="translate(9 9.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="32" height="32" rx="16" fill="#F1F1F1" />
                <g clipPath="url(#clip0_365_977)">
                  <g clipPath="url(#clip1_365_977)">
                    <g clipPath="url(#clip2_365_977)">
                      <path
                        d="M16.3546 14.6379H19.5546L19.199 16.0602H16.3546V22.4602H14.9323V16.0602H12.0879V14.6379H14.9323V13.3067C14.9323 12.0388 15.0646 11.5787 15.3121 11.1151C15.5546 10.657 15.9292 10.2824 16.3873 10.0399C16.8509 9.79242 17.311 9.66016 18.5789 9.66016C18.9501 9.66016 19.2758 9.69571 19.5546 9.76682V11.0824H18.5789C17.6374 11.0824 17.3508 11.1378 17.0586 11.2943C16.8424 11.4095 16.6817 11.5702 16.5665 11.7864C16.41 12.0786 16.3546 12.3652 16.3546 13.3067V14.6379Z"
                        fill="#FFA500"
                        stroke="#FFA500"
                        strokeWidth="0.8"
                      />
                    </g>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_365_977">
                    <rect
                      width="10"
                      height="14"
                      fill="white"
                      transform="translate(11 9)"
                    />
                  </clipPath>
                  <clipPath id="clip1_365_977">
                    <rect
                      width="10"
                      height="14"
                      fill="white"
                      transform="translate(11 9)"
                    />
                  </clipPath>
                  <clipPath id="clip2_365_977)">
                    <rect
                      width="10"
                      height="14"
                      fill="white"
                      transform="translate(11 9)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="32" height="32" rx="16" fill="#F1F1F1" />
                <g clipPath="url(#clip0_365_982)">
                  <g clipPath="url(#clip1_365_982)">
                    <g clipPath="url(#clip2_365_982)">
                      <path
                        d="M21.0798 12.6561L21.0865 12.663C21.1753 12.7527 21.268 12.9491 21.3394 13.192C21.3716 13.3018 21.3944 13.4028 21.4091 13.4763C21.4163 13.5127 21.4214 13.5417 21.4246 13.5608L21.4279 13.5814L21.4284 13.5852L21.432 13.616C21.4351 13.6434 21.4396 13.6841 21.4451 13.7363C21.4561 13.8406 21.4707 13.9903 21.4854 14.1701C21.5149 14.5311 21.544 15.0076 21.544 15.4796V16.399C21.544 16.8722 21.5149 17.3487 21.4854 17.7093C21.4707 17.889 21.4561 18.0385 21.4451 18.1426C21.4397 18.1946 21.4351 18.2352 21.432 18.2626L21.4284 18.2933L21.428 18.2969L21.4246 18.3178C21.4214 18.3369 21.4163 18.3659 21.4091 18.4023C21.3944 18.4758 21.3716 18.5769 21.3394 18.6867C21.268 18.9295 21.1753 19.1259 21.0865 19.2155L21.0798 19.2225C20.7974 19.5191 20.5115 19.549 20.2597 19.5754C20.2339 19.5781 20.2085 19.5808 20.1835 19.5837C19.3536 19.6426 18.3121 19.6736 17.4715 19.6898C17.0504 19.6979 16.6818 19.7022 16.4185 19.7046C16.2869 19.7057 16.1817 19.7064 16.1095 19.7067L16.0268 19.7071L16.0055 19.7071L16.0002 19.7072L15.9952 19.7071L15.969 19.7068L15.868 19.7058C15.7806 19.7048 15.6544 19.7034 15.5 19.7013C15.1911 19.6972 14.7692 19.6908 14.3175 19.6815C13.419 19.663 12.4293 19.6335 11.9584 19.5906C11.8777 19.5758 11.799 19.5653 11.7223 19.5551C11.4284 19.5159 11.1626 19.4805 10.9169 19.2225L10.9113 19.2167C10.8231 19.127 10.7307 18.9303 10.6595 18.6872C10.6273 18.5773 10.6046 18.4762 10.59 18.4026C10.5828 18.3661 10.5776 18.337 10.5745 18.318L10.5711 18.2973L10.5707 18.2934L10.5671 18.2626C10.564 18.2352 10.5594 18.1945 10.5539 18.1423C10.543 18.038 10.5283 17.8883 10.5136 17.7085C10.4841 17.3475 10.4551 16.871 10.4551 16.399V15.4796C10.4551 15.008 10.4847 14.5318 10.5147 14.1709C10.5297 13.9912 10.5447 13.8416 10.5558 13.7373C10.5614 13.6852 10.566 13.6445 10.5692 13.6171L10.5729 13.5864L10.5735 13.5815L10.5737 13.5801L10.5769 13.5595C10.5801 13.5404 10.5851 13.5114 10.5922 13.475C10.6067 13.4016 10.6292 13.3006 10.6612 13.1909C10.7319 12.9482 10.8242 12.7523 10.9125 12.663L10.9192 12.6561C11.2017 12.3595 11.4876 12.3296 11.7394 12.3032C11.7652 12.3005 11.7908 12.2978 11.8159 12.2949C12.6453 12.2349 13.6858 12.2044 14.5258 12.1891C14.9466 12.1815 15.3148 12.1777 15.5778 12.1757C15.7093 12.1748 15.8143 12.1743 15.8864 12.1741L15.969 12.1739L15.9902 12.1738H15.9955L15.9968 12.1738H16.0019L16.0035 12.1738H16.0088L16.03 12.1739L16.1126 12.1741C16.1847 12.1743 16.2898 12.1748 16.4212 12.1757C16.6842 12.1777 17.0525 12.1815 17.4732 12.1891C18.3133 12.2044 19.3538 12.2349 20.1832 12.2949C20.2083 12.2978 20.2338 12.3005 20.2597 12.3032C20.5114 12.3296 20.7974 12.3595 21.0798 12.6561ZM14.2505 17.5152V18.339L14.9813 17.9587L18.2467 16.2596L19.0961 15.8176L18.2479 15.3732L14.9825 13.6623L14.2505 13.2787V14.1052V17.5152Z"
                        fill="#FFA500"
                        stroke="#FFA500"
                      />
                    </g>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_365_982">
                    <rect
                      width="14"
                      height="10"
                      fill="white"
                      transform="translate(9 11)"
                    />
                  </clipPath>
                  <clipPath id="clip1_365_982">
                    <rect
                      width="14"
                      height="10"
                      fill="white"
                      transform="translate(9 11)"
                    />
                  </clipPath>
                  <clipPath id="clip2_365_982">
                    <rect
                      width="14"
                      height="10"
                      fill="white"
                      transform="translate(9 11)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="32" height="32" rx="16" fill="#F1F1F1" />
                <g clipPath="url(#clip0_365_987)">
                  <g clipPath="url(#clip1_365_987)">
                    <g clipPath="url(#clip2_365_987)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.7813 11.9801C18.653 12.0658 18.553 12.1876 18.494 12.3301C18.446 12.446 18.4269 12.5713 18.4375 12.6954C18.44 12.7239 18.444 12.7525 18.4496 12.7808C18.4797 12.9321 18.554 13.0711 18.6631 13.1802C18.7721 13.289 18.9114 13.3636 19.0625 13.3936C19.0913 13.3994 19.1203 13.4034 19.1494 13.4059C19.273 13.4163 19.3978 13.397 19.5132 13.3492C19.6557 13.2902 19.7775 13.1902 19.8632 13.062C19.9026 13.0029 19.9336 12.9392 19.9556 12.8725C19.9813 12.7942 19.9947 12.7119 19.9947 12.6286C19.9947 12.6161 19.9944 12.6037 19.9938 12.5913C19.9934 12.5824 19.9928 12.5734 19.992 12.5645C19.9782 12.397 19.9106 12.2382 19.7991 12.112C19.7885 12.1001 19.7776 12.0884 19.7662 12.0771C19.7639 12.0747 19.7615 12.0723 19.7591 12.07C19.6227 11.9371 19.4427 11.8589 19.2532 11.8496C19.2516 11.8495 19.25 11.8494 19.2484 11.8493C19.2372 11.8489 19.226 11.8486 19.2147 11.8486C19.1274 11.8486 19.0413 11.8632 18.9597 11.8914C18.897 11.9131 18.8371 11.9428 18.7813 11.9801ZM18.9559 10.8675C19.0428 10.8834 19.1291 10.9024 19.2147 10.9245C19.3288 10.954 19.4416 10.9891 19.5527 11.0296C19.8408 11.1366 20.1002 11.3088 20.3105 11.5327C20.3157 11.5383 20.321 11.544 20.3262 11.5496C20.5392 11.7493 20.7056 11.9934 20.8137 12.2646C20.8573 12.3841 20.8946 12.5056 20.9254 12.6286C20.9456 12.7095 20.9631 12.7911 20.9778 12.8731C21.0147 13.0795 21.0338 13.2891 21.0347 13.4996C21.0672 14.1496 21.0737 14.3901 21.0737 16.0996C21.0737 17.8091 21.0672 18.0496 21.0347 18.6996C21.0299 19.1122 20.9552 19.521 20.8137 19.9086C20.7098 20.1915 20.5432 20.4471 20.3262 20.6561C20.1153 20.871 19.8603 21.0373 19.5787 21.1436C19.1911 21.2851 18.7823 21.3598 18.3696 21.3646C17.7326 21.3996 17.5116 21.4036 15.7696 21.4036C14.0601 21.4036 13.8196 21.4036 13.1696 21.3646C12.5256 21.3727 11.9914 21.3066 11.4861 21.1696C11.6394 21.0579 11.396 20.8919 11.1936 20.6821C10.9779 20.4733 10.8133 20.2175 10.7126 19.9346C10.554 19.5415 10.4659 19.1234 10.4526 18.6996C10.4526 18.4517 10.447 18.2633 10.44 18.0303C10.4286 17.6524 10.4136 17.1571 10.4136 16.0996C10.4136 14.3901 10.4136 14.1496 10.4526 13.4996C10.4556 13.0778 10.5326 12.6598 10.6801 12.2646C10.7946 11.9903 10.9702 11.7457 11.1936 11.5496C11.3911 11.3261 11.6352 11.1486 11.9086 11.0296C12.3049 10.8866 12.7224 10.8119 13.1436 10.8086C13.3916 10.8086 13.5799 10.8029 13.8129 10.7959C14.1908 10.7845 14.6862 10.7696 15.7436 10.7696C17.4531 10.7696 17.6937 10.7696 18.3436 10.8086C18.5494 10.811 18.7542 10.8307 18.9559 10.8675ZM21.9057 20.3571C21.7421 20.7914 21.4846 21.1843 21.1517 21.5076C20.8298 21.8408 20.4364 22.0964 20.0012 22.2551C19.4959 22.4461 18.9617 22.5494 18.4216 22.5606C17.7326 22.5996 17.5116 22.5996 15.7436 22.5996C13.9756 22.5996 13.7546 22.5996 13.0656 22.5606C12.5256 22.5494 11.9914 22.4461 11.4861 22.2551C11.0517 22.0948 10.6587 21.8394 10.3356 21.5076C10.0025 21.1857 9.74687 20.7923 9.58815 20.3571C9.39716 19.8518 9.29384 19.3176 9.28265 18.7776C9.24365 18.0886 9.24365 17.8676 9.24365 16.0996C9.24365 14.3316 9.24365 14.1106 9.28265 13.4216C9.29384 12.8816 9.39716 12.3474 9.58815 11.8421C9.74687 11.4069 10.0025 11.0135 10.3356 10.6916C10.6587 10.3598 11.0517 10.1044 11.4861 9.94411C11.9914 9.75311 12.5256 9.6498 13.0656 9.63861C13.7546 9.59961 13.9756 9.59961 15.7436 9.59961C17.5116 9.59961 17.7326 9.59961 18.4216 9.63861C18.9617 9.6498 19.4959 9.75311 20.0012 9.94411C20.4364 10.1028 20.8298 10.3584 21.1517 10.6916C21.4832 11.0161 21.7404 11.4087 21.9057 11.8421C22.0911 12.3487 22.192 12.8823 22.2047 13.4216C22.2437 14.1106 22.2437 14.3316 22.2437 16.0996C22.2437 17.1881 22.2289 17.6902 22.2175 18.0762C22.2104 18.3171 22.2047 18.5128 22.2047 18.7776C22.192 19.3169 22.0911 19.8505 21.9057 20.3571ZM13.3946 18.4597C12.928 17.9941 12.6099 17.4005 12.4805 16.7541C12.3511 16.1077 12.4162 15.4375 12.6676 14.828C12.919 14.2186 13.3454 13.6974 13.8929 13.3302C14.4404 12.9631 15.0844 12.7664 15.7436 12.7651C16.1823 12.7634 16.617 12.8484 17.0227 13.0153C17.2127 13.0935 17.3945 13.1888 17.5661 13.3C17.7606 13.426 17.9419 13.5722 18.1068 13.7366C18.1067 13.7366 18.1068 13.7367 18.1068 13.7366C18.107 13.7369 18.1074 13.7373 18.1077 13.7375C18.2728 13.9024 18.4198 14.0837 18.5464 14.2784C18.6578 14.4497 18.7535 14.6313 18.8319 14.821C18.9996 15.2264 19.0855 15.6609 19.0847 16.0996C19.0847 16.7588 18.8892 17.4033 18.5231 17.9515C18.1571 18.4997 17.6366 18.9271 17.0277 19.1797C16.4188 19.4322 15.7487 19.4987 15.102 19.3705C14.4554 19.2424 13.8612 18.9255 13.3946 18.4597ZM19.3702 12.473C19.3701 12.4729 19.3702 12.473 19.3702 12.473V12.473ZM19.3702 12.473L19.2147 12.6285L19.418 12.7127C19.4291 12.6859 19.4347 12.6573 19.4347 12.6286C19.4347 12.6143 19.4333 12.6 19.4305 12.5858C19.422 12.5432 19.4009 12.5038 19.3702 12.473ZM19.2147 12.6285L19.418 12.7127C19.4124 12.7261 19.4056 12.7389 19.3976 12.7508C19.3816 12.7748 19.361 12.7954 19.3369 12.8115C19.3249 12.8196 19.3122 12.8264 19.2989 12.8319C19.2989 12.8318 19.2989 12.8319 19.2989 12.8319C19.2724 12.8428 19.2437 12.8486 19.2147 12.8486C19.2001 12.8486 19.1858 12.8472 19.1717 12.8444L19.2147 12.6285ZM19.0591 12.7841C19.059 12.7841 19.0591 12.7842 19.0591 12.7841V12.7841ZM19.2147 12.6285L19.0591 12.7841C19.09 12.8151 19.1294 12.836 19.1717 12.8444L19.2147 12.6285ZM19.0591 12.7841L19.2147 12.6285L19.0114 12.5444C19.0004 12.5709 18.9946 12.5995 18.9946 12.6286C18.9946 12.6432 18.9961 12.6576 18.9989 12.6716C19.0074 12.7139 19.0281 12.7531 19.0591 12.7841ZM19.0114 12.5444L19.2147 12.6285L19.2575 12.4128C19.2434 12.41 19.229 12.4086 19.2147 12.4086C19.186 12.4086 19.1574 12.4142 19.1306 12.4253C19.1305 12.4254 19.1306 12.4253 19.1306 12.4253C19.1172 12.4309 19.1044 12.4377 19.0925 12.4457C19.0685 12.4617 19.0478 12.4823 19.0317 12.5064M19.2147 12.6285L19.2575 12.4128C19.3003 12.4213 19.3396 12.4424 19.3702 12.473L19.2147 12.6285ZM19.0114 12.5444C19.0169 12.5311 19.0237 12.5184 19.0317 12.5064L19.0114 12.5444ZM14.5411 17.8993C14.8971 18.1371 15.3156 18.2641 15.7436 18.2641C16.0279 18.2641 16.3094 18.2081 16.572 18.0994C16.8346 17.9906 17.0732 17.8311 17.2742 17.6301C17.4752 17.4292 17.6346 17.1905 17.7434 16.9279C17.8522 16.6653 17.9081 16.3839 17.9081 16.0996C17.9081 15.6715 17.7812 15.253 17.5434 14.8971C17.3055 14.5411 16.9675 14.2637 16.572 14.0999C16.1765 13.9361 15.7412 13.8932 15.3214 13.9767C14.9015 14.0602 14.5158 14.2664 14.2131 14.5691C13.9104 14.8718 13.7043 15.2575 13.6207 15.6773C13.5372 16.0972 13.5801 16.5324 13.7439 16.9279C13.9077 17.3234 14.1852 17.6615 14.5411 17.8993Z"
                        fill="#FFA500"
                      />
                    </g>
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_365_987">
                    <rect
                      width="14"
                      height="14"
                      fill="white"
                      transform="translate(9 9)"
                    />
                  </clipPath>
                  <clipPath id="clip1_365_987">
                    <rect
                      width="14"
                      height="14"
                      fill="white"
                      transform="translate(9 9)"
                    />
                  </clipPath>
                  <clipPath id="clip2_365_987">
                    <rect
                      width="14"
                      height="14"
                      fill="white"
                      transform="translate(9 9)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        {/* <div className="w-full max-w-[603px] h-auto gap-0 rounded-lg bg-white border border-custom-gray mt-[32px] lg:mt-0 lg:ml-[200px] lg:mr-[120px] p-[16px] sm:p-[32px]  box-border">
          <div className="flex flex-col sm:flex-row justify-between">
            <div className="w-full sm:w-[48%] mr-0 sm:mr-[15px]">
              <div className="w-full h-[18px] font-primary text-[16px] font-medium leading-[18px] text-left text-custom-blue mb-[8px]">
                First Name
              </div>
              <input
                type="text"
                className="w-full h-[48px] rounded-xl border border-custom-gray px-[15px] box-border"
              />
            </div>
            <div className="w-full sm:w-[48%] mt-[16px] sm:mt-0">
              <div className="w-full h-[18px] font-primary text-[16px] font-medium leading-[18px] text-left text-custom-blue mb-[8px]">
                Last Name
              </div>
              <input
                type="text"
                className="w-full h-[48px] rounded-xl border border-custom-gray px-[15px] box-border"
              />
            </div>
          </div>

          <div className="mt-[24px]">
            <div className="w-full h-[18px] font-primary text-[16px] font-medium leading-[18px] text-left text-custom-blue mb-[8px]">
              Email Address
            </div>
            <input
              type="email"
              className="w-full h-[48px] rounded-xl border border-custom-gray px-[15px] box-border"
            />
          </div>

          <div className="mt-[24px]">
            <div className="w-full h-[18px] font-primary text-[16px] font-medium leading-[18px] text-left text-custom-blue mb-[8px]">
              Message
            </div>
            <textarea
              className="w-full h-[181px] rounded-xl border border-custom-gray p-[15px] box-border resize-none"
            />
          </div>

          <button
            className="w-full h-[48px] mt-[24px] rounded-xl bg-custom-blue text-white font-primary text-[16px] font-medium leading-[18px] text-center"
          >
            Submit
          </button>
        </div> */}
        {/* <div
          className="ngp-form"
          data-form-url="https://secure.everyaction.com/v1/Forms/VkwtriA-I0KQHP6chvFS1g2"
          data-custom-css="https://nvlupin.blob.core.windows.net/designs/CustomStylesheet_59b9b6652237f4d3f99e4a4fd4ff8226a80b0c8492a2499f229bb760a7026c18.css"
          data-fastaction-endpoint="https://fastaction.ngpvan.com"
          data-inline-errors="true"
          data-fastaction-nologin="true"
          data-mobile-autofocus="false"
        ></div> */}

        <div className="mt-4 lg:mt-0 h-[1400px] md:h-[1150px] w-full">
          <iframe
            src="https://secure.everyaction.com/VkwtriA-I0KQHP6chvFS1g2"
            className="w-full flex-1 h-full"
          />
        </div>
      </div>

      <div className="w-full h-[300px] sm:h-[448px] gap-0 opacity-100 mx-auto mt-[150px] sm:mt-[326px]">
        <iframe
          title="Google Maps Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.2838494377847!2d-89.65293258430823!3d39.781721979443954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x887525f4e153c67b%3A0x34d8f648f13727c2!2s2208%20E%20Kansas%20St%2C%20Springfield%2C%20IL%2062703%2C%20USA!5e0!3m2!1sen!2sin!4v1628096164148!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
      <div className="pt-[81px] pb-[87px]">
        <Newsletter />
      </div>
    </>
  );
};

export default ContactUs;
